module.exports = __webpack_public_path__ + "home.d14453c5d449482e385b74398f71e749.svg";